import { Shipment } from 'src/generated/services/TFinancialApi';

/**
 * Groups shipments by prioritizing NRCF items first
 */
const NRCF_WORKFLOWS = ['PROCUREMENT_NO_CONTRACT_REVIEW', 'OPS_ADMIN_NO_CONTRACT_REVIEW'];

export const groupNrcfItemsFirst = (items: Shipment[]): Shipment[] => {
  const nrcfItems = items.filter((item) => NRCF_WORKFLOWS.includes(item?.currentDeviationWorkflow || ''));
  const nonNrcfItems = items.filter((item) => !NRCF_WORKFLOWS.includes(item?.currentDeviationWorkflow || ''));
  return [...nrcfItems, ...nonNrcfItems];
};

export interface HighlightedPart {
  text: string;
  isHighlighted: boolean;
}

/**
 * Splits text into parts and marks which parts should be highlighted
 */
export const getHighlightedParts = (text: string, keyword: string): HighlightedPart[] => {
  if (!keyword || !text) {
    return [{ text, isHighlighted: false }];
  }

  const regex = new RegExp(`(${keyword.replace(/[.*+?^${}()|[\]\\]/g, '\\$&')})`, 'g');
  const parts = text.split(regex);

  return parts.map((part) => ({
    text: part,
    isHighlighted: part === keyword,
  }));
};

/**
 * Generates types text for shipment (Deviations, Approvals, NRCF)
 */
export const getShipmentTypesText = (deviationCount?: number, approvalCount?: number, isNoRateCard?: boolean): string => {
  const types = [];
  if (deviationCount && deviationCount > 0) {
    types.push(`${deviationCount} Deviation${deviationCount > 1 ? 's' : ''}`);
  }
  if (approvalCount && approvalCount > 0) {
    types.push(`${approvalCount} Approval${approvalCount > 1 ? 's' : ''}`);
  }
  if (isNoRateCard) {
    types.push('NRCF');
  }
  return types.join(' - ');
};
